import { useEffect, useRef } from 'react';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import {
  useTargetVisitsStore,
  type TargetMetricsSnapshot,
} from '../store/targetVisitsStore';
import {
  formatTargetScopeKey,
  type TargetScope,
} from '../utils/target-scope.utils';

export function usePersistTargetVisit({
  targetId,
  targetType,
  snapshot,
}: {
  targetId: string | null;
  targetType: TargetTypeType;
  snapshot: TargetMetricsSnapshot | null;
}) {
  const recordVisit = useTargetVisitsStore((state) => state.recordVisit);
  const saveMetricsSnapshot = useTargetVisitsStore(
    (state) => state.saveMetricsSnapshot,
  );
  const snapshotRef = useRef(snapshot);
  snapshotRef.current = snapshot;

  const scopeKey = targetId
    ? formatTargetScopeKey({ targetId, targetType } satisfies TargetScope)
    : null;

  useEffect(() => {
    return () => {
      if (!scopeKey || !snapshotRef.current) {
        return;
      }

      saveMetricsSnapshot(scopeKey, snapshotRef.current);
      recordVisit(scopeKey);
    };
  }, [scopeKey, recordVisit, saveMetricsSnapshot]);
}
